export default "__VITE_ASSET__5Zzm_EmW__"